export class ProductFeeDto {
  feeType: string;
  amount: number;
  percentage: number;
  waiveCount: number;
  insufficientFundAction: string;
  startMonth: string;
  endMonth: number;
  startDays: number;
  occurrences = 0;
  frequencyCount = 0;
  dateType: string;
  dayToRun: number;
  freebieCount = 0;
  skipCreatedMonth: number;
  productId: string;
  id?: string;

  constructor(d?: ProductFeeDto) {
    if (!d) {
      return;
    }

    Object.assign(this, d);
    this.occurrences = this.occurrences || 0;
    this.freebieCount = this.freebieCount || 0;
    this.frequencyCount = this.frequencyCount || 0;
  }
}
